export interface DateValidationErrors {
  prazo_aceite?: string;
  prazo_para_conclusao?: string;
  data?: string;
}

export const validateDateNotPast = (date: Date | string | null | undefined, fieldName: string): string | null => {
  if (!date) return null;
  
  const dateObj = date instanceof Date ? date : new Date(date);
  if (isNaN(dateObj.getTime())) {
    return `${fieldName} inválida`;
  }
  
  const agora = new Date();
  if (dateObj < agora) {
    return `${fieldName} não pode ser passada`;
  }
  
  return null;
};

export const validatePrazoFatalComplete = (
  dataPrazoFatal: Date | string | null | undefined,
  dataCriacao?: Date | string | null | undefined
): DateValidationErrors => {
  const errors: DateValidationErrors = {};
  const agora = new Date();

  if (!dataPrazoFatal) {
    errors.data = 'Prazo fatal é obrigatório';
    return errors;
  }

  const dataFatal = dataPrazoFatal instanceof Date ? dataPrazoFatal : new Date(dataPrazoFatal);
  if (isNaN(dataFatal.getTime())) {
    errors.data = 'Data do prazo fatal inválida';
    return errors;
  }

  const horas = dataFatal.getHours();
  const minutos = dataFatal.getMinutes();
  const segundos = dataFatal.getSeconds();
  const milissegundos = dataFatal.getMilliseconds();
  
  if (horas === 0 && minutos === 0 && segundos === 0 && milissegundos === 0) {
    errors.data = 'Data e hora fatal são obrigatórias';
    return errors;
  }

  if (dataFatal < agora) {
    errors.data = 'Prazo fatal não pode ser anterior à data atual';
  }

  if (dataCriacao) {
    const criacao = dataCriacao instanceof Date ? dataCriacao : new Date(dataCriacao);
    if (!isNaN(criacao.getTime()) && dataFatal < criacao) {
      errors.data = 'Prazo fatal não pode ser anterior à data de criação da demanda';
    }
  }

  return errors;
};

export const validatePrazoAceiteComPrazoFatal = (
  prazoAceite: Date | string | null | undefined,
  prazoFatal: Date | string | null | undefined
): string | null => {
  if (!prazoAceite || !prazoFatal) {
    return null;
  }

  const aceite = prazoAceite instanceof Date ? prazoAceite : new Date(prazoAceite);
  const fatal = prazoFatal instanceof Date ? prazoFatal : new Date(prazoFatal);

  if (isNaN(aceite.getTime()) || isNaN(fatal.getTime())) {
    return null;
  }

  if (aceite.getTime() === fatal.getTime()) {
    return 'Prazo de aceite não pode ser igual ao prazo fatal';
  }

  if (aceite > fatal) {
    return 'Prazo de aceite deve ser anterior ao prazo fatal';
  }

  const diferencaMs = fatal.getTime() - aceite.getTime();
  const diferencaHoras = diferencaMs / (1000 * 60 * 60);
  
  if (diferencaHoras < 1) {
    return 'Prazo fatal deve ter pelo menos 1 hora de diferença do prazo de aceite';
  }

  return null;
};

export const validatePrazoConclusaoComPrazoFatal = (
  prazoConclusao: Date | string | null | undefined,
  prazoFatal: Date | string | null | undefined
): string | null => {
  if (!prazoConclusao || !prazoFatal) {
    return null;
  }

  const conclusao = prazoConclusao instanceof Date ? prazoConclusao : new Date(prazoConclusao);
  const fatal = prazoFatal instanceof Date ? prazoFatal : new Date(prazoFatal);

  if (isNaN(conclusao.getTime()) || isNaN(fatal.getTime())) {
    return null;
  }

  if (conclusao.getTime() === fatal.getTime()) {
    return 'Prazo de conclusão não pode ser igual ao prazo fatal';
  }

  if (conclusao < fatal) {
    return 'Prazo de conclusão deve ser posterior ao prazo fatal';
  }

  const diferencaMs = conclusao.getTime() - fatal.getTime();
  const diferencaHoras = diferencaMs / (1000 * 60 * 60);
  
  if (diferencaHoras < 1) {
    return 'Prazo de conclusão deve ter pelo menos 1 hora de diferença do prazo fatal';
  }

  return null;
};

export const validatePrazosRelacao = (
  prazoAceite: Date | string | null | undefined,
  prazoConclusao: Date | string | null | undefined
): DateValidationErrors => {
  const errors: DateValidationErrors = {};

  if (!prazoAceite || !prazoConclusao) {
    return errors;
  }

  const aceite = prazoAceite instanceof Date ? prazoAceite : new Date(prazoAceite);
  const conclusao = prazoConclusao instanceof Date ? prazoConclusao : new Date(prazoConclusao);

  if (isNaN(aceite.getTime()) || isNaN(conclusao.getTime())) {
    return errors;
  }

  if (aceite.getTime() === conclusao.getTime()) {
    errors.prazo_aceite = 'Os prazos não podem ser iguais';
    errors.prazo_para_conclusao = 'Os prazos não podem ser iguais';
  } else if (aceite > conclusao) {
    errors.prazo_aceite = 'Prazo de aceite deve ser anterior ao prazo de conclusão';
  }

  return errors;
};

